(function () {
  var cache = new Map();
  var synonyms = {
    'ramen bowl': 'donburi',
    'plate': 'dinner plate', 'plates': 'dinner plate', 'cup': 'teacup', 'cups': 'teacup'
  };
  var baseVocabulary = ['bowl', 'bowls', 'plate', 'plates', 'cup', 'cups', 'refrigerator', 'refrigeration', 'melamine', 'flatware', 'glassware', 'cookware', 'furniture', 'disposables', 'chopsticks', 'donburi', 'tabletop'];
  var smartSearchId = 0;

  function setOpenState(form, isOpen) {
    form.classList.toggle('is-smart-search-open', isOpen);

    var stackingRoot = form.closest('.site-header, #mobileNavBar, #navBar');
    if (stackingRoot) stackingRoot.classList.toggle('is-smart-search-open', isOpen);
  }

  function distance(a, b) {
    var row = Array.from({ length: b.length + 1 }, function (_, i) { return i; });
    for (var i = 1; i <= a.length; i++) {
      var next = [i];
      for (var j = 1; j <= b.length; j++) next[j] = Math.min(next[j - 1] + 1, row[j] + 1, row[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      row = next;
    }
    return row[b.length];
  }

  function vocabulary() {
    var words = baseVocabulary.slice();
    document.querySelectorAll('.site-nav--link, .custom-mega-category-text').forEach(function (item) {
      var value = item.textContent.trim().toLowerCase();
      if (value && words.indexOf(value) === -1) words.push(value);
      value.split(/\s+/).forEach(function (word) { if (word.length > 3 && words.indexOf(word) === -1) words.push(word); });
    });
    return words;
  }

  function correctQuery(raw) {
    var query = raw.trim().toLowerCase();
    if (synonyms[query]) return synonyms[query];
    if (query.length < 4 || /\d/.test(query)) return query;
    var best = query, bestDistance = Infinity;
    vocabulary().forEach(function (candidate) {
      if (candidate.charAt(0) !== query.charAt(0) || Math.abs(candidate.length - query.length) > 3) return;
      var score = distance(query, candidate);
      if (score < bestDistance) { bestDistance = score; best = candidate; }
    });
    return bestDistance <= Math.max(2, Math.floor(query.length * .28)) ? best : query;
  }

  function recent() { try { return JSON.parse(localStorage.getItem('edenRecentSearches') || '[]'); } catch (e) { return []; } }
  function remember(value) {
    if (!value) return;
    var values = recent().filter(function (item) { return item.toLowerCase() !== value.toLowerCase(); });
    values.unshift(value); try { localStorage.setItem('edenRecentSearches', JSON.stringify(values.slice(0, 6))); } catch (e) {}
  }
  function escapeHtml(value) { var el = document.createElement('div'); el.textContent = value; return el.innerHTML; }
  function starterMarkup(searchUrl) {
    var saved = recent();
    function links(items) { return items.map(function (item) { return '<div class="smart-search__recent-row"><a role="option" data-smart-option href="' + escapeHtml(searchUrl) + '?type=product&q=' + encodeURIComponent(item) + '"><span class="smart-search__clock" aria-hidden="true"></span><span>' + escapeHtml(item) + '</span></a><button type="button" data-remove-recent="' + encodeURIComponent(item) + '" aria-label="Remove ' + escapeHtml(item) + ' from recent searches">&times;</button></div>'; }).join(''); }
    return saved.length ? '<div class="smart-search__content"><section class="smart-search__group smart-search__recent"><div class="smart-search__group-heading"><h3>Recent Searches</h3><button type="button" data-clear-recent>Clear</button></div>' + links(saved) + '</section></div>' : '';
  }

  function initSmartSearch(root) {
    var forms = [];
    if (root.matches && root.matches('[data-smart-search]')) forms.push(root);
    forms = forms.concat(Array.prototype.slice.call(root.querySelectorAll('[data-smart-search]')));

    forms.forEach(function (form) {
    if (form.getAttribute('data-smart-search-initialized') === 'true') return;
    form.setAttribute('data-smart-search-initialized', 'true');
    var input = form.querySelector('input[type="search"]');
    var panel = form.querySelector('[data-smart-search-results]');
    if (!input || !panel) return;
    var searchUrl = form.getAttribute('data-search-url') || '/search';
    var predictiveSearchUrl = form.getAttribute('data-predictive-search-url') || '/search/suggest';
    panel.id = 'SmartSearchResults-' + (++smartSearchId);
    input.setAttribute('aria-controls', panel.id);
    var timer, controller, activeIndex = -1;

    function options() {
      var items = Array.prototype.slice.call(panel.querySelectorAll('[data-smart-option]'));
      items.forEach(function(item, index) {
        if (!item.id) item.id = panel.id + '-option-' + index;
      });
      return items;
    }
    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      setOpenState(form, true);
    }
    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      setOpenState(form, false);
    }
    function activate(index) {
      var items = options(); if (!items.length) return;
      activeIndex = (index + items.length) % items.length;
      items.forEach(function (item, i) { item.classList.toggle('is-active', i === activeIndex); item.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', items[activeIndex].id);
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    }
    function highlightProductTitles(query) {
      var normalizedQuery = query.toLocaleLowerCase();
      panel.querySelectorAll('[data-smart-product-title]').forEach(function (title) {
        var original = title.getAttribute('data-smart-product-title') || '';
        var matchStart = original.toLocaleLowerCase().indexOf(normalizedQuery);

        title.textContent = original;
        if (!normalizedQuery || matchStart === -1) return;

        var mark = document.createElement('mark');
        mark.textContent = original.slice(matchStart, matchStart + query.length);
        title.replaceChildren(
          document.createTextNode(original.slice(0, matchStart)),
          mark,
          document.createTextNode(original.slice(matchStart + query.length))
        );
      });
    }
    function render(html, query) {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('[data-predictive-content]');
      panel.innerHTML = content ? content.outerHTML : '';
      if (!panel.querySelector('[data-smart-option]')) { close(); return; }
      /*
        Shopify's highlight filter wraps matches in <strong>. Product titles
        already use <strong>, so the generated nested elements inherit the
        title's overflow rules and can visually consume adjacent whitespace.
        Rebuild highlighting from the exact stored title with text nodes so the
        rendered text always remains exactly equivalent to the stored title.
      */
      highlightProductTitles(query);
      var products = Array.prototype.slice.call(panel.querySelectorAll('.smart-search__product'));
      products.sort(function (a, b) {
        var exactA = a.dataset.title === query ? 1 : 0, exactB = b.dataset.title === query ? 1 : 0;
        return exactB - exactA || Number(b.dataset.popularity || 0) - Number(a.dataset.popularity || 0) || Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
      }).forEach(function (item) { item.parentNode.appendChild(item); });
      open();
    }
    function search(raw) {
      var query = raw.trim().toLowerCase();
      if (query.length < 2) { panel.innerHTML = starterMarkup(searchUrl); if (panel.innerHTML) open(); else close(); return; }
      /*
        Predictive search must use exactly what the customer typed. Expanding
        "plate" to "dinner plate" here hid exact collection matches and caused
        Shopify's styled query suggestion to highlight words the customer did
        not enter. Synonyms remain available for the zero-results correction.
      */
      var key = query;
      if (cache.has(key)) { render(cache.get(key), query); return; }
      var immediate = [];
      document.querySelectorAll('.site-nav--link, .custom-mega-category').forEach(function (link) {
        var title = link.textContent.trim();
        if (title && title.toLowerCase().indexOf(query) !== -1 && !immediate.some(function (item) { return item.title === title; })) immediate.push({ title: title, href: link.href });
      });
      if (immediate.length) {
        panel.innerHTML = '<div class="smart-search__content"><section class="smart-search__group smart-search__inline-taxonomy">' + immediate.slice(0, 6).map(function (item) { return '<a role="option" data-smart-option href="' + escapeHtml(item.href) + '"><span>' + escapeHtml(item.title) + '</span><small>Collection</small></a>'; }).join('') + '</section></div>';
        open();
      }
      if (controller) controller.abort(); controller = new AbortController();
      var url = predictiveSearchUrl + '?q=' + encodeURIComponent(query) + '&section_id=predictive-search&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku';
      fetch(url, { signal: controller.signal }).then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed with status ' + response.status);
        return response.text();
      }).then(function (html) {
        if (input.value.trim().toLowerCase() !== query) return;
        cache.set(key, html);
        render(html, query);
      }).catch(function (error) { if (error.name !== 'AbortError') close(); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { search(input.value); }, 70); });
    input.addEventListener('focus', function () { search(input.value); });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') { event.preventDefault(); open(); activate(activeIndex + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); activate(activeIndex - 1); }
      else if (event.key === 'Escape') { close(); }
      else if (event.key === 'Enter' && activeIndex >= 0) { event.preventDefault(); options()[activeIndex].click(); }
    });
    form.addEventListener('submit', function () {
      var original = input.value.trim();
      remember(original);
    });
    panel.addEventListener('click', function (event) { var option = event.target.closest('[data-smart-option]'); if (option) remember(option.dataset.title || option.textContent.trim()); });
    panel.addEventListener('click', function (event) { if (!event.target.closest('[data-clear-recent]')) return; try { localStorage.removeItem('edenRecentSearches'); } catch (e) {} panel.innerHTML = ''; close(); input.focus(); });
    panel.addEventListener('click', function (event) { var remove = event.target.closest('[data-remove-recent]'); if (!remove) return; event.preventDefault(); event.stopPropagation(); var value = decodeURIComponent(remove.getAttribute('data-remove-recent')); try { localStorage.setItem('edenRecentSearches', JSON.stringify(recent().filter(function (item) { return item !== value; }))); } catch (e) {} panel.innerHTML = starterMarkup(searchUrl); if (!panel.innerHTML) close(); input.focus(); });
    var clear = form.querySelector('[data-smart-search-clear]');
    function syncClear() { if (clear) clear.hidden = !input.value; }
    if (clear) clear.addEventListener('click', function () { input.value = ''; syncClear(); panel.innerHTML = starterMarkup(searchUrl); if (panel.innerHTML) open(); else close(); input.focus(); });
    input.addEventListener('input', syncClear); syncClear();
  });
  }

  initSmartSearch(document);
  document.addEventListener('shopify:section:load', function(event) { initSmartSearch(event.target); });
  document.addEventListener('click', function(event) {
    document.querySelectorAll('[data-smart-search]').forEach(function(form) {
      if (form.contains(event.target)) return;
      var panel = form.querySelector('[data-smart-search-results]');
      var input = form.querySelector('input[type="search"]');
      if (panel) panel.hidden = true;
      setOpenState(form, false);
      if (input) {
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }
    });
  });

  document.querySelectorAll('[data-search-correction]').forEach(function (container) {
    var original = container.getAttribute('data-query') || '';
    var suggestion = correctQuery(original);
    if (!suggestion || suggestion === original.trim().toLowerCase()) return;
    var searchUrl = window.theme && window.theme.routes && window.theme.routes.searchUrl ? window.theme.routes.searchUrl : '/search';
    container.href = searchUrl + '?type=product&q=' + encodeURIComponent(suggestion);
    container.innerHTML = 'Search instead for &ldquo;' + escapeHtml(suggestion) + '&rdquo;';
    container.hidden = false;
  });
})();
